// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  WBS_CLOSE_SNACK_BAR,
} from './constants';

export function closeSnackBar() {
  return {
    type: WBS_CLOSE_SNACK_BAR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case WBS_CLOSE_SNACK_BAR:
      return {
        ...state,
        openSnackBar:false,
        messageSnackBar:''
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/wbs/redux/closeSnackBar.js